import { seedProvinces } from "data/seedProvinces";

export const themes = ["Nature", "History", "Food", "Adventure", "Sea", "Culture"];

export { seedProvinces };

export const seedDeals = [
  {
    id: "d-1",
    provinceId: "trabzon",
    title: "Uzungöl Hafta Sonu Kaçamağı",
    description: "2 kişilik konaklama + kahvaltı (MVP örnek).",
    priceText: "₺3.950 / 2 gece",
    startDate: "2025-12-20",
    endDate: "2026-03-31",
    theme: "Nature",
    contactCta: "WhatsApp ile iletişim",
  },
  {
    id: "d-2",
    provinceId: "rize",
    title: "Ayder Termal Günü",
    description: "Günübirlik termal + transfer (MVP örnek).",
    priceText: "₺1.250 / kişi",
    startDate: "2025-12-01",
    endDate: "2026-04-30",
    theme: "Nature",
    contactCta: "Arayın",
  },
  {
    id: "d-3",
    provinceId: "artvin",
    title: "Borçka Karagöl Fotoğraf Turu",
    description: "Rehberli kısa rota, sabah çıkış (MVP örnek).",
    priceText: "₺990 / kişi",
    startDate: "2026-03-01",
    endDate: "2026-11-15",
    theme: "Adventure",
    contactCta: "Form doldurun",
  },
];

export const seedBusinesses = [
  {
    id: "b-1",
    provinceId: "trabzon",
    name: "Uzungöl Dağ Evi",
    description: "Göl manzaralı butik otel. Şömine, doğa yürüyüşleri ve organik kahvaltı.",
    category: "hotel",
    ownerUserId: "partner-1",
    rating: 4.7,
    reviewCount: 124,
    priceText: "₺1.800 / gece",
    phone: "+90 462 555 0001",
    website: "https://example.com/uzungol-dag-evi",
    facilities: ["wifi", "breakfast", "parking", "fireplace"],
    location: { latitude: 40.6167, longitude: 40.2833 },
  },
  {
    id: "b-2",
    provinceId: "rize",
    name: "Çamlıhemşin Lezzet Sofrası",
    description: "Yöresel Karadeniz mutfağı. Muhlama, kuymak ve taze alabalık.",
    category: "restaurant",
    ownerUserId: "partner-1",
    rating: 4.5,
    reviewCount: 89,
    priceText: "₺250 / kişi",
    phone: "+90 464 555 0002",
    website: null,
    facilities: ["wifi", "parking"],
    location: { latitude: 41.1267, longitude: 40.9167 },
  },
  {
    id: "b-3",
    provinceId: "artvin",
    name: "Artvin Doğa Turları",
    description: "Karagöl, Şavşat ve vadilere rehberli günlük turlar.",
    category: "tour_agency",
    ownerUserId: "partner-2",
    rating: 4.8,
    reviewCount: 56,
    priceText: "₺750 / tur",
    phone: "+90 466 555 0003",
    website: "https://example.com/artvin-turlar",
    facilities: [],
    location: { latitude: 41.1828, longitude: 41.8183 },
  },
  {
    id: "b-4",
    provinceId: "samsun",
    name: "Samsun Marina Otel",
    description: "Sahil kenarında modern otel. Deniz manzaralı odalar ve SPA.",
    category: "hotel",
    ownerUserId: "partner-2",
    rating: 4.3,
    reviewCount: 201,
    priceText: "₺2.400 / gece",
    phone: "+90 362 555 0004",
    website: "https://example.com/samsun-marina",
    facilities: ["wifi", "breakfast", "parking", "spa", "bar", "tv"],
    location: { latitude: 41.2867, longitude: 36.33 },
  },
  {
    id: "b-5",
    provinceId: "trabzon",
    name: "Akçaabat Köfte Evi",
    description: "1952'den beri Akçaabat köftesi ve pide.",
    category: "restaurant",
    ownerUserId: "partner-1",
    rating: 4.6,
    reviewCount: 332,
    priceText: "₺180 / kişi",
    phone: "+90 462 555 0005",
    website: null,
    facilities: ["parking"],
    location: { latitude: 41.0217, longitude: 39.6117 },
  },
  {
    id: "b-6",
    provinceId: "sinop",
    name: "Sinop Rehber Hizmetleri",
    description: "Sinop Kalesi, İnceburun ve tarihi mekanlar için profesyonel rehberlik.",
    category: "guide",
    ownerUserId: "partner-2",
    rating: 4.9,
    reviewCount: 28,
    priceText: "₺500 / gün",
    phone: "+90 368 555 0006",
    website: null,
    facilities: [],
    location: { latitude: 42.0231, longitude: 35.1531 },
  },
];
